import { Avatar, Space, Stack, Title } from '@mantine/core';

export const OtherParticipantNotAvailable = ({
  message,
  participantProfilePicture,
  participantName,
  children
}: {
  message: string;
  participantProfilePicture: string;
  participantName: string;
  children?: React.ReactNode;
}) => {
  return (
    <Stack justify="center" align="center" gap={5} h="100%">
      <Avatar
        src={participantProfilePicture}
        alt={participantName}
        size={100}
        radius={80}
      />
      <Space h={5} />
      <Title order={2} fw="normal">
        {participantName}
      </Title>
      <Title order={4} fw="normal" c="dimmed" ta='center'>
        {message}
      </Title>
      {children}
    </Stack>
  );
};
